const Contacto = () => <div className="page-content">Page B Content</div>;

export default Contacto;
